import * as React from 'react';
import * as elementGroupStyles from './elementGroup/ElementGroup.css';
import * as styles from './Megamenu.css';
import { inject, observer } from 'mobx-react';
import { NavigatorStore } from './../stores';
import { ElementGroup } from './elementGroup/ElementGroup';
import { IAIcon } from '../../icon/Icon';
import { Burgerbar } from './topItems/sidebar/Burgerbar';
import { HorizontalBar } from './topItems/horizontalBar/HorizontalBar';
import 'element-matches';
import { Helper } from '../../../Helper';
import { LocalizationService } from '../../../services/LocalizationService';
import { UPARROW_KEY_CODE } from '../../../global/Constants';
import { KeyNavigationGlobalCache } from '../KeyNavigationGlobalCache';

export interface IMegamenuProps {
  version: string;
  toogleMegamenu: boolean;
  navigatorStore?: NavigatorStore;
}

export interface IMegamenuState {
  marginTop: number;
}

@inject('navigatorStore')
@observer
export class Megamenu extends React.Component<IMegamenuProps, IMegamenuState> {


  constructor(props: IMegamenuProps) {
    super(props);
    this.state = {
      marginTop: -screen.availHeight,
    };

  }

  public componentWillMount(): void {
    this.props.navigatorStore?.getTopItems();
    this.checkLocationChange();
  }

  public componentWillReceiveProps(props: IMegamenuProps): void {
    if (props.version != this.props.version) {
      this.props.navigatorStore?.getTopItems();
    }
    if (props.toogleMegamenu != this.props.toogleMegamenu) {
      this.toogleMegamenu(props.toogleMegamenu);
    }
  }

  private checkLocationChange(): void {
    window.addEventListener('popstate', () => this.closeMegaMenu());
    window.addEventListener('replaceState', () => this.closeMegaMenu());
    window.addEventListener('pushState', () => this.closeMegaMenu());
    const { pushState, replaceState } = window.history;
    window.history.pushState = (...args) => {
      pushState.apply(window.history, args);
      window.dispatchEvent(new Event('pushState'));
    };
    window.history.replaceState = (...args) => {
      replaceState.apply(window.history, args);
      window.dispatchEvent(new Event('replaceState'));
    };
  }

  private closeMegaMenu(): void {
    this.props.navigatorStore.isShowingMegamenuAnimation = false;
    setTimeout(() => {
      this.props.navigatorStore.isShowingMegamenu = false;
      this.props.navigatorStore.selectedTopMenuItemIndex = undefined;
    }, 200);
  }

  private toogleMegamenu(show: boolean): void {
    console.log("Toggling megamenu, show: ", show);
    let marginTop = 0;
    if (!isNaN(this.props.navigatorStore?.contentTop) && !isNaN(this.props.navigatorStore?.contentHeight)) {
      marginTop = show
        ? this.props.navigatorStore?.contentTop
        : -(this.props.navigatorStore?.contentTop + this.props.navigatorStore?.contentHeight);
      if (this.props.navigatorStore?.navigator?.design?.menuBar?.layout === 'burger' && show) {
        marginTop = 0;
      }
    }
    if (this.props.navigatorStore?.isInEditMode) {
      marginTop = marginTop - 48;
    }

    if (this.props.navigatorStore?.isMobile) {
      marginTop = 0;
    }
    if (show) {
      setTimeout(() => {
        this.setState({ marginTop });
      }, 200);
    } else {
      this.setState({ marginTop });
    }
  }

  render() {
    let topItemContent = [];
    let selectedTopItemIndex: number;
    let selectedTopItemColumnWidth: number;
    if (
      (!this.props.navigatorStore?.isMobile &&
        !this.props.navigatorStore?.isIpadInPortrait &&
        this.props.navigatorStore?.navigator?.design?.menuBar?.showSlimPanel == undefined) ||
      (!this.props.navigatorStore?.isMobile &&
        !this.props.navigatorStore?.isIpadInPortrait &&
        !this.props.navigatorStore?.navigator?.design?.menuBar?.showSlimPanel) ||
      this.props.navigatorStore?.isInEditMode ||
      this.props.navigatorStore?.isClassic
    ) {
      this.props.navigatorStore?.navigator.megamenu.topItems.forEach((topItem: any, topItemIndex) => {
        let columns: JSX.Element[] = [];
        let columnWidth;
        let numberOfColumns = this.props.navigatorStore?.isInEditMode
          ? topItem.elementGroups.length + 1
          : topItem.elementGroups.length;
        let standardWidth: number = 440 * numberOfColumns + 55;
        let elementGroupsAreaWidth: number =
          this.props.navigatorStore?.navigator?.design?.menuBar?.layout === 'burger'
            ? this.props.navigatorStore?.width - 300
            : this.props.navigatorStore?.width;
        if (standardWidth > elementGroupsAreaWidth) {
          columnWidth = (elementGroupsAreaWidth - 55) / numberOfColumns - 17;
        } else {
          columnWidth = 400;
        }
        if (this.props.navigatorStore?.selectedTopMenuItemIndex == topItemIndex) {
          selectedTopItemIndex = topItemIndex;
          selectedTopItemColumnWidth = (columnWidth + 55) * topItem.elementGroups.length;
          if (selectedTopItemColumnWidth > this.props.navigatorStore?.width) {
            selectedTopItemColumnWidth = this.props.navigatorStore?.width;
          }
        }
        topItem.elementGroups.forEach((column: any[], columnIndex) => {
          let elementGroups: JSX.Element[] = [];
          column.forEach((elementGroup: any, elementGroupIndex) => {
            if (this.props.navigatorStore?.droppableElementGroupSpotsAreShowing) {
              elementGroups.push(
                <div
                  className={styles.elementGroupDroppable}
                  key={`elementGroupDroppable_${elementGroupIndex}`}
                  style={{
                    color: this.props.navigatorStore?.navigator.design.elements.textColor,
                    border: `1px dashed ${this.props.navigatorStore?.navigator.design.elements.textColor}`,
                    opacity: 0.5,
                  }}
                  onDragOver={() => event.preventDefault()}
                  onDragEnter={() => event.preventDefault()}
                  onDrop={() => {
                    this.props.navigatorStore?.updateElementGroupPosition(topItemIndex, columnIndex, elementGroupIndex);
                  }}
                >
                  {new LocalizationService().strings.Navigator_Megamenu_DropItem}
                </div>
              );
            }
            if (this.props.navigatorStore?.checktargetedPreviewIds(elementGroup)) {
              elementGroups.push(
                <ElementGroup
                  key={`elementGroups_${elementGroupIndex}`}
                  config={elementGroup.config}
                  elements={elementGroup.elements}
                  topItemIndex={topItemIndex}
                  columnIndex={columnIndex}
                  index={elementGroupIndex}
                  width={columnWidth}
                  type={elementGroup.type}
                />
              );
            }
          });
          if (this.props.navigatorStore?.droppableElementGroupSpotsAreShowing) {
            elementGroups.push(
              <div
                className={styles.elementGroupDroppable}
                key={`elementGroupDroppableUnder_${columnIndex}`}
                style={{
                  color: this.props.navigatorStore?.navigator.design.elements.textColor,
                  border: `1px dashed ${this.props.navigatorStore?.navigator.design.elements.textColor}`,
                  opacity: 0.5,
                }}
                onDragOver={() => event.preventDefault()}
                onDragEnter={() => event.preventDefault()}
                onDrop={() => {
                  this.props.navigatorStore?.updateElementGroupPosition(topItemIndex, columnIndex, column.length);
                }}
              >
                {new LocalizationService().strings.Navigator_Megamenu_DropItem}
              </div>
            );
          }
          columns.push(
            <div
              className={styles.column}
              style={{
                width: columnWidth != undefined ? columnWidth : 0,
              }}
              key={`column_${columnIndex}`}
            >
              {elementGroups}
              {this.props.navigatorStore?.isInEditMode &&
                !this.props.navigatorStore?.droppableElementGroupSpotsAreShowing &&
                !this.props.navigatorStore?.droppableElementSpotsAreShowing &&
                !this.props.navigatorStore?.droppableTopItemSpotsAreShowing && (
                  <div
                    className={elementGroupStyles.elementAddNewButton}
                    key={`elementAddNewButton1_${columnIndex}`}
                    style={{
                      height: 100,
                      border: `1px dashed ${this.props.navigatorStore?.navigator.design.elementGroups.textColor}`,
                      width: 'calc(100% - 10px)',
                    }}
                    onClick={() => {
                      if (!this.props.navigatorStore?.isShowingAnalytics && !this.props.navigatorStore?.checkedOut) {
                        this.props.navigatorStore?.addElementGroup(topItemIndex, columnIndex);
                      }
                    }}
                  >
                    <div className={elementGroupStyles.elementAddNewButtonIcon}>
                      <IAIcon
                        title="Add"
                        size={20}
                        color={this.props.navigatorStore?.navigator.design.elementGroups.textColor}
                      />
                    </div>
                    <div
                      className={elementGroupStyles.elementAddNewButtonText}
                      style={{
                        color: this.props.navigatorStore?.navigator.design.elementGroups.textColor,
                      }}
                    >
                      {new LocalizationService().strings.Navigator_Megamenu_AddGroup}
                    </div>
                  </div>
                )}
            </div>
          );
        });
        if (this.props.navigatorStore?.isInEditMode) {
          columns.push(
            <div
              key={`column_${Helper.getRandomStringKey()}`}
              className={styles.column}
              style={{
                width: columnWidth,
                marginRight: 0,
              }}
            >
              {!this.props.navigatorStore?.droppableElementGroupSpotsAreShowing &&
                !this.props.navigatorStore?.droppableElementSpotsAreShowing &&
                !this.props.navigatorStore?.droppableTopItemSpotsAreShowing && (
                  <div
                    className={elementGroupStyles.elementAddNewButton}
                    key={`elementAddNewButton2_${topItemIndex}`}
                    style={{
                      height: 100,
                      border: `1px dashed ${this.props.navigatorStore?.navigator.design.elementGroups.textColor}`,
                      width: 'calc(100% - 10px)',
                    }}
                    onClick={() => {
                      if (!this.props.navigatorStore?.isShowingAnalytics && !this.props.navigatorStore?.checkedOut) {
                        this.props.navigatorStore?.addElementGroup(topItemIndex);
                      }
                    }}
                  >
                    <div className={elementGroupStyles.elementAddNewButtonIcon}>
                      <IAIcon
                        title="Add"
                        size={20}
                        color={this.props.navigatorStore?.navigator.design.elementGroups.textColor}
                      />
                    </div>
                    <div
                      className={elementGroupStyles.elementAddNewButtonText}
                      style={{
                        color: this.props.navigatorStore?.navigator.design.elementGroups.textColor,
                      }}
                    >
                      {new LocalizationService().strings.Navigator_Megamenu_AddGroup}
                    </div>
                  </div>
                )}
              {!this.props.navigatorStore?.droppableElementGroupSpotsAreShowing && (
                <div
                  className={elementGroupStyles.elementAddNewButton}
                  key={`elementAddNewButton3_${topItemIndex}`}
                  onClick={() => {
                    if (!this.props.navigatorStore?.checkedOut && !this.props.navigatorStore?.isShowingAnalytics) {
                      if (this.props.navigatorStore?.droppableElementSpotsAreShowing) {
                        this.props.navigatorStore?.hideDroppableElementSpots();
                      } else {
                        this.props.navigatorStore?.showDroppableElementSpots();
                      }
                    }
                  }}
                >
                  <div className={elementGroupStyles.elementAddNewButtonIcon}>
                    <IAIcon
                      title={this.props.navigatorStore?.droppableElementSpotsAreShowing ? 'Checkmark' : 'Move'}
                      size={20}
                      color={this.props.navigatorStore?.navigator.design.elementGroups.textColor}
                    />
                  </div>
                  <div
                    className={elementGroupStyles.elementAddNewButtonText}
                    style={{
                      color: this.props.navigatorStore?.navigator.design.elementGroups.textColor,
                      paddingLeft: 5,
                    }}
                  >
                    {this.props.navigatorStore?.droppableElementSpotsAreShowing
                      ? new LocalizationService().strings.Navigator_Megamenu_DoneReordering
                      : new LocalizationService().strings.Navigator_Megamenu_ReorderItems}
                  </div>
                </div>
              )}
              {!this.props.navigatorStore?.droppableElementSpotsAreShowing && (
                <div
                  className={elementGroupStyles.elementAddNewButton}
                  key={`elementAddNewButton4_${topItemIndex}`}
                  onClick={() => {
                    if (!this.props.navigatorStore?.checkedOut && !this.props.navigatorStore?.isShowingAnalytics) {
                      if (this.props.navigatorStore?.droppableElementGroupSpotsAreShowing) {
                        this.props.navigatorStore?.hideDroppableElementGroupSpots();
                      } else {
                        this.props.navigatorStore?.showDroppableElementGroupSpots();
                      }
                    }
                  }}
                >
                  <div className={elementGroupStyles.elementAddNewButtonIcon}>
                    <IAIcon
                      title={this.props.navigatorStore?.droppableElementGroupSpotsAreShowing ? 'Checkmark' : 'Move'}
                      size={20}
                      color={this.props.navigatorStore?.navigator.design.elementGroups.textColor}
                    />
                  </div>
                  <div
                    className={elementGroupStyles.elementAddNewButtonText}
                    style={{
                      color: this.props.navigatorStore?.navigator.design.elementGroups.textColor,
                      paddingLeft: 5,
                    }}
                  >
                    {this.props.navigatorStore?.droppableElementGroupSpotsAreShowing
                      ? new LocalizationService().strings.Navigator_Megamenu_DoneReordering
                      : new LocalizationService().strings.Navigator_Megamenu_ReorderGroups}
                  </div>
                </div>
              )}
            </div>
          );
        }
        topItemContent.push(columns);
      });
    }
    if (
      this.props.navigatorStore?.isIpadInPortrait ||
      (this.props.navigatorStore?.navigator?.design?.menuBar?.showSlimPanel &&
        !this.props.navigatorStore?.isInEditMode &&
        this.props.navigatorStore?.navigator?.design?.menuBar?.layout == 'vertical')
    ) {
      this.props.navigatorStore?.navigator.megamenu.topItems.forEach((topItem: any, topItemIndex) => {
        if (this.props.navigatorStore?.selectedTopMenuItemIndex == topItemIndex) {
          selectedTopItemIndex = topItemIndex;
        }
        let columnWidth: number = this.props.navigatorStore?.width ?? 0;
        if (this.props.navigatorStore?.navigator?.design?.menuBar?.layout == 'burger') {
          columnWidth = this.props.navigatorStore?.width - 340;
        }
        if (this.props.navigatorStore?.navigator?.design?.menuBar?.layout == 'vertical') {
          if (this.props.navigatorStore?.verticalMenuExpanded) {
            columnWidth = this.props.navigatorStore?.width - 340;
          } else {
            columnWidth = this.props.navigatorStore?.width - 55;
          }
          if (this.props.navigatorStore?.navigator?.design?.menuBar?.showSlimPanel) {
            columnWidth = 510;
          }
        }
        let elementGroups: JSX.Element[] = [];
        topItem.elementGroups.forEach((column: any[], columnIndex) => {
          column.forEach((elementGroup: any, elementGroupIndex) => {
            if (this.props.navigatorStore?.checktargetedPreviewIds(elementGroup)) {
              elementGroups.push(
                <ElementGroup
                  key={`elementGroup_${elementGroupIndex}_${topItemIndex}_${columnIndex}`}
                  config={elementGroup.config}
                  elements={elementGroup.elements}
                  topItemIndex={topItemIndex}
                  columnIndex={columnIndex}
                  index={elementGroupIndex}
                  width={columnWidth}
                  type={elementGroup.type}
                />
              );
            }
          });
        });
        topItemContent.push(
          <div
            key={`topItemContent_${topItemIndex}`}
            className={styles.column}
            style={{
              width: columnWidth != undefined ? columnWidth : 0,
            }}
          >
            {elementGroups}
          </div>
        );
      });
    };
    if (this.props.navigatorStore?.navigator != undefined) {
      let design = this.props.navigatorStore?.navigator.design;
      let megamenuWidth: number | string = this.props.navigatorStore?.width;
      let megamenuContentWidth = design.menuBar.layout === 'burger' ? this.props.navigatorStore?.width - 300 : '100%';

      if (this.props.navigatorStore?.isMobile) {
        megamenuWidth = "100%";
      }
      // Top menu item position calculation
      const navigatorWidth = document.getElementById(this.props.navigatorStore?.id)?.getBoundingClientRect()?.width;
      const logoWidth = document.getElementById("IA_navigator_logo")?.getBoundingClientRect()?.width ?? 0;
      let topMenuItemPosition = document.getElementById(`topMenuItem_id_${this.props.navigatorStore?.selectedTopMenuItemIndex}`)?.getBoundingClientRect() != undefined ? document.getElementById(`topMenuItem_id_${this.props.navigatorStore?.selectedTopMenuItemIndex}`)?.getBoundingClientRect().left - 38 : 0;
      if (this.props.navigatorStore?.navigator?.design?.menuBar?.logo) {
        topMenuItemPosition = topMenuItemPosition + logoWidth + 14;
      }
      if (!document.getElementById("sp-appBar")) {
        topMenuItemPosition = topMenuItemPosition + 47; // sp app bar width
      }
      topMenuItemPosition = topMenuItemPosition + (this.props.navigatorStore?.navigationBarOffset < 28 ? 0 : this.props.navigatorStore?.navigationBarOffset - (this.props.navigatorStore?.navigator?.design?.menuBar?.logo ? 10 : 28)); // offset
      // Check for overflow or if more than 3 columns
      if ((topMenuItemPosition + selectedTopItemColumnWidth > navigatorWidth) || this.props.navigatorStore?.navigator?.megamenu?.topItems[this.props.navigatorStore?.selectedTopMenuItemIndex]?.elementGroups?.length > 3) {
        if (this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType == "modern" && this.props.navigatorStore?.navigator?.design?.menuBar?.followGrid) {
          topMenuItemPosition = (navigatorWidth - this.props.navigatorStore?.getCanvasWidth()) / 2;
          megamenuWidth = "100%";
          selectedTopItemColumnWidth = this.props.navigatorStore?.getCanvasWidth();
        } else {
          topMenuItemPosition = 0;
          selectedTopItemColumnWidth = navigatorWidth;
        }
      }
      //
      return (
        <>
          {design.menuBar.layout === 'horizontal' && <HorizontalBar />}
          {this.props.navigatorStore?.isShowingMegamenu && !this.props.navigatorStore?.isMobile && !this.props.navigatorStore?.isShowingAnalytics && (
            <div
              style={{
                position: 'absolute',
                height: document.documentElement.clientHeight,
                width: "100%",
                zIndex: 900000,
                backgroundColor: 'rgba(0, 0, 0, 0.24)',
                transition: 'opacity 200ms ease-in-out',
                opacity: this.props.navigatorStore?.isShowingMegamenuAnimation ? 1 : 0,
              }}
              onClick={() => {
                this.closeMegaMenu();
              }}
            />
          )}
          <div
            className={styles.megamenu}
            id="megamenu"
            onKeyDown={(event: React.KeyboardEvent<HTMLDivElement>) => {
              var index = this.props.navigatorStore?.selectedTopMenuItemIndex;
              if (event.which === UPARROW_KEY_CODE && (index || index === 0)) {
                event.preventDefault();
                KeyNavigationGlobalCache.topItemRefs[index].focus();
              }
            }}
            style={{
              width: megamenuWidth ?? "100%",
              marginTop: design.menuBar.layout === 'burger' && this.props.navigatorStore?.isInEditMode ? 0 : this.state.marginTop,
              top: design.menuBar.layout === 'burger' && !this.props.navigatorStore?.asMobileAppComponent ? (this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType === "standard" ? 40 : 80) : 0,
              zIndex: this.props.navigatorStore?.isShowingAnalytics ? 900999 : 900001,
              opacity: this.props.navigatorStore?.isShowingMegamenu ? 1 : 0,
              height: this.props.navigatorStore?.asMobileAppComponent ? "100%" : (this.props.navigatorStore?.isShowingMegamenu ? this.props.navigatorStore?.isMobile ? "100vh" : undefined : 0),
              transition: this.props.navigatorStore?.isInEditMode
                ? 'opacity 200ms ease-in-out'
                : 'margin-top 200ms ease-in-out,  margin-left 200ms ease-in-out',
              marginLeft: this.props.navigatorStore?.isInEditMode || this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType === "standard" || this.props.navigatorStore?.isMobile ? 0 : topMenuItemPosition
            }}
          >
            {design.menuBar.layout === 'burger' && <Burgerbar />}
            {!this.props.navigatorStore?.isMobile && (
              <div
                className={styles.megamenuContent}
                id="megamenuContent"
                style={{
                  width: this.props.navigatorStore?.isInEditMode || this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType === "standard" ? megamenuContentWidth : selectedTopItemColumnWidth,
                  backgroundColor: design.elementGroups.backgroundColor,
                  maxHeight: this.props.navigatorStore?.contentHeight,
                  padding: this.props.navigatorStore?.isInEditMode && this.props.navigatorStore?.checkedOut && (!this.props.navigatorStore?.isShowingAnalytics || this.props.navigatorStore?.selectedTopMenuItemIndex === undefined) ? 0 : "",
                  boxShadow: design.menuBar.layout === 'burger' ? undefined : "rgba(0, 0, 0, 0.2) 0px 3px 5px 0px",
                  zIndex: this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType === "standard" ? 900001 : 900002,
                  marginTop: this.props.navigatorStore?.navigator?.design?.menuBar?.navigatorType === "standard" ? 0 : 40,
                }}
              >
                {topItemContent[selectedTopItemIndex]}
              </div>
            )}
          </div>
        </>
      );
    } else {
      return <div className={styles.megamenu}></div>;
    }
  }
}